/**
 * Coercion rules for values that arrive from a TanStack Router search.
 *
 * The router parses the query string with `JSON.parse`, so `validateSearch` does
 * NOT receive strings: `?cp=true` arrives as the boolean `true` and `?cp=["5"]`
 * as an array — both of which `Number()` happily turns into a real id (1 and 5).
 * The page then filters by a counterparty the user never named AND normalises the
 * URL to `?cp=1`, so the wrong scope looks deliberate and travels in a shared
 * link. (LR-551; LR-587 put the same parser on `/collateral`.)
 */

/**
 * A positive integer id from a search param, or `undefined`.
 *
 * Accepts a number or a plain run of digits and nothing else — no coercion from
 * booleans, arrays, objects or hex literals. `isSafeInteger`, not `isInteger`:
 * the latter is true for `1e+24` and for values past 2^53, which `Number()` has
 * already rounded to a *different* id.
 */
export const parsePositiveIntParam = (value: unknown): number | undefined => {
  if (typeof value === 'string' ? !/^\d+$/.test(value.trim()) : typeof value !== 'number') {
    return undefined;
  }
  const n = Number(value);
  return Number.isSafeInteger(n) && n > 0 ? n : undefined;
};
